(function($) {
	'use strict';
	$.fn.Slide__InsightPopup = function() {
		this.each(function() {

			/*
			 * Action: Add slide to collection
			 */
			var $self = $(this),
				data = $self.data('insightdata'),
				o_ratio = data.image_w / data.image_h,
				$parent = $self.parent(),
				timeout = 0,

				// The actual func
				position_it = function() {

					var parent_w = $parent.width(),
						parent_h = $parent.height(),
						p_ratio = parent_w / parent_h,
						image = {},
						p_of_o = 0; // <= percentage of original

					/*
					 * Calculate actual image width / height
					 */
					// Is portrait or landscape per the original ratio
					if( o_ratio > p_ratio ) {

						// height determines image width
						image.height = $parent.height();
						image.width = Math.round( data.image_w * ( image.height / data.image_h ) );

						// Offsets
						image.offset_x = ( image.width - parent_w ) / 2; // <= remainder / 2
						image.offset_y = 0;

					} else {

						// width determines image height
						image.width = parent_w;
						image.height = Math.round( data.image_h * ( image.width / data.image_w ) );

						// Offsets
						image.offset_x = 0;
						image.offset_y = ( image.height - parent_h ) / 2; // <= remainder / 2

					}

					// Get the percentage of original so we can calculate our new coords
					p_of_o = image.width / data.image_w;


					// Calculations
					var point_css = {
						'left': ( data.coords[0] * p_of_o ) - image.offset_x,
						'top': ( data.coords[1] * p_of_o ) - image.offset_y,
					};

					// Update coord positioning
					$self.css( point_css );


					// Popup positioning
					var popup_css;

					if( 'left' === data.x_orientation ) {

						// Left orientation
						popup_css = {
							bottom: parent_h - point_css.top + 24, // <= 18 is offset from $self
							right: parent_w - point_css.left - 20,
						};

					} else {

						// Right orientation
						popup_css = {
							bottom: parent_h - point_css.top + 24, // <= 18 is offset from $self
							right: parent_w - point_css.left - 220,
						};

					}

					// Update coord positioning
					$self.siblings('#' + data.id ).css( popup_css );

				};





			/*
			 * Positioning of the points
			 */
			// Need images loaded
			$.Window.on('resize.insight-popups', function() {

				clearTimeout( timeout );

				// Reset Timeout
				timeout = setTimeout( position_it, 300 );

			}).on('load.insight-popups', function() {
				$.Window.trigger('resize.insight-popups');
			});



		});
		return this;
	};
}(jQuery));
